// styles
import styled from 'styled-components';
import SoFormCandidateBlockDetailsInputDay from './SoFormCandidateBlockDetailsInputDay';
import SoFormCandidateBlockDetailsInputLabel from './SoFormCandidateBlockDetailsInputLabel';
import SoEconomyWindowCheckbox from './SoEconomyWindowCheckbox';
import { getFormattedDateFromDate } from './economyUtils';
import SoEconomyRangePicker from './SoEconomyRangePicker';
import moment from 'moment-timezone';
import { useSoFormStepsApi } from 'refactored/features/soForm/SoForm.context';
import { useTranslation } from 'react-i18next';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
`;

const ColumnsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;

const SoFormCandidateBlockDetailsInputsEconomy = ({ candidate, className }) => {
  const stepsApi = useSoFormStepsApi();

  const shipment = candidate.formData.quotePayload.shipments[0];
  const { t } = useTranslation('Catalog');

  //   pickup day
  const inputDayPickupData = {
    formattedDate: getFormattedDateFromDate(
      new Date(shipment.pickup_time_from)
    ),
    value: new Date(shipment.pickup_time_from),
    minDate: new Date(candidate.formData.minTime),
    handleChange: (e) => {
      const selectedDate = moment(e);
      const newDayOfYear = selectedDate.dayOfYear();
      const newTimes = {
        pickup_time_from: moment(shipment.pickup_time_from)
          .dayOfYear(newDayOfYear)
          .year(selectedDate.year())
          .toJSON(),
        pickup_date_from: moment(shipment.pickup_date_from)
          .dayOfYear(newDayOfYear)
          .year(selectedDate.year())
          .format('YYYY-MM-DD'),
        pickup_time_to: moment(shipment.pickup_time_to)
          .dayOfYear(newDayOfYear)
          .year(selectedDate.year())
          .toJSON(),
        pickup_date_to: moment(shipment.pickup_date_to)
          .dayOfYear(newDayOfYear)
          .year(selectedDate.year())
          .format('YYYY-MM-DD'),
        dropoff_time_from: moment(shipment.dropoff_time_from)
          .dayOfYear(newDayOfYear)
          .year(selectedDate.year())
          .toJSON(),
        dropoff_date_from: moment(shipment.dropoff_date_from)
          .dayOfYear(newDayOfYear)
          .year(selectedDate.year())
          .format('YYYY-MM-DD'),
        dropoff_time_to: moment(shipment.dropoff_time_to)
          .dayOfYear(newDayOfYear)
          .year(selectedDate.year())
          .toJSON(),
        dropoff_date_to: moment(shipment.dropoff_date_to)
          .dayOfYear(newDayOfYear)
          .year(selectedDate.year())
          .format('YYYY-MM-DD'),
      };
      stepsApi.setEconomyRange({ newTimes, candidate });
    },
    disableWeekends: true,
    disabledDays: [],
  };

  return (
    <div className={className}>
      <SoFormCandidateBlockDetailsInputLabel>
        {t('price.economy.pickup_and_dropoff_the_same_day')}
      </SoFormCandidateBlockDetailsInputLabel>
      <SoFormCandidateBlockDetailsInputDay inputDayData={inputDayPickupData} />
      <ColumnsContainer>
        <InputContainer>
          <SoFormCandidateBlockDetailsInputLabel>
            {t('price.economy.pickup_hour')}
          </SoFormCandidateBlockDetailsInputLabel>
          <SoEconomyRangePicker candidate={candidate} isPickup={true} />
        </InputContainer>
        <InputContainer>
          <SoFormCandidateBlockDetailsInputLabel>
            {t('price.economy.dropoff_hour')}
          </SoFormCandidateBlockDetailsInputLabel>
          <SoEconomyRangePicker candidate={candidate} isPickup={false} />
        </InputContainer>
      </ColumnsContainer>

      <SoEconomyWindowCheckbox candidate={candidate} />
    </div>
  );
};

export default styled(SoFormCandidateBlockDetailsInputsEconomy)`
  display: flex;
  flex-direction: column;
  padding: 12px 16px 16px;
  gap: 16px;
  width: 100%;
`;
